import React from 'react';

import { Alert, Flex, Typography } from 'antd';

const { Link, Text } = Typography;

export const ErrorAlertPartnerStats = ({ refetch }) => (
  <Flex gap=".5rem" style={{ width: '100%' }}>
    <Alert
      showIcon
      type="error"
      message="We are having trouble loading the partner stats."
      description={
        <Text>
          Please{' '}
          <Link onClick={refetch} data-testid="refetch-partner-stats">
            try again
          </Link>{' '}
          or contact support.
        </Text>
      }
      style={{ width: '100%' }}
    />
  </Flex>
);
